export default __webpack_public_path__ + "static/media/dashIcon.3a878a56.svg";